// the Uniswap Default token list lives here
// export const DEFAULT_TOKEN_LIST_URL = 'tokens.uniswap.eth'
export const DEFAULT_TOKEN_LIST_URL = 'https://raw.githubusercontent.com/ChewySwap/chewy-tokenlist/main/tokenLists/ChewyTokenList.json'
export const DEGEN_TOKEN_LIST_URL = 'https://raw.githubusercontent.com/PooDoge/dogeshrek-degens-tokenlist/main/tokenLists/dogeShrekTokenList.json'

export const DEFAULT_LIST_OF_LISTS: string[] = [DEFAULT_TOKEN_LIST_URL, DEGEN_TOKEN_LIST_URL]
